<template>
  <layout-no-menu>
    <ion-header>
      <ion-toolbar color="primary">
        <ion-buttons slot="start">
          <ion-icon name="arrow-round-back" size="large" @click="$router.go(-1)"></ion-icon>
        </ion-buttons>
        <ion-title>Platform Settings</ion-title>
      </ion-toolbar>
    </ion-header>
    <ion-content>
      <ion-list v-if="settings">
        <ion-list-header><ion-label>Payments</ion-label></ion-list-header>
        <ion-item>
          <ion-label position="stacked">Default platform fee (%) · allowed {{ settings.minFeePercent }}–{{ settings.maxFeePercent }}</ion-label>
          <ion-input type="number" inputmode="decimal" step="0.1" :min="settings.minFeePercent" :max="settings.maxFeePercent"
            :value="form.platformFeePercent" @input="form.platformFeePercent = $event.target.value"></ion-input>
        </ion-item>
        <ion-item>
          <ion-label>Who pays the fee by default</ion-label>
          <ion-select :value="form.feePayerDefault" interface="popover" @ionChange="form.feePayerDefault = $event.detail.value">
            <ion-select-option value="Host">Host (deducted from payout)</ion-select-option>
            <ion-select-option value="Buyer">Buyer (processing fee at checkout)</ion-select-option>
          </ion-select>
        </ion-item>
        <ion-item lines="none">
          <ion-label text-wrap><p>New tournaments copy these values when payments are set up. Running tournaments keep their own; change those on the tournament.</p></ion-label>
        </ion-item>
        <ion-item v-if="error" lines="none"><ion-label text-wrap color="danger"><p>{{ error }}</p></ion-label></ion-item>
        <ion-item v-if="saved" lines="none"><ion-label color="success"><p>Saved.</p></ion-label></ion-item>
        <div class="ion-padding-horizontal">
          <ion-button expand="block" :disabled="busy" @click="save">Save</ion-button>
        </div>
      </ion-list>
      <ion-item v-else-if="error" lines="none"><ion-label text-wrap color="danger"><p>{{ error }}</p></ion-label></ion-item>
    </ion-content>
  </layout-no-menu>
</template>

<script>
import PaymentAPI from "@/services/PaymentAPI";
const paymentAPI = new PaymentAPI();

export default {
  name: "PlatformSettings",
  data() {
    return { settings: null, form: { platformFeePercent: "", feePayerDefault: "Host" }, busy: false, error: "", saved: false };
  },
  methods: {
    async load() {
      try {
        this.settings = await paymentAPI.platformSettings();
        this.form = { platformFeePercent: this.settings.platformFeePercent, feePayerDefault: this.settings.feePayerDefault };
      } catch (e) {
        this.error = typeof e === "string" ? e : "Could not load settings.";
      }
    },
    async save() {
      this.busy = true;
      this.error = "";
      this.saved = false;
      try {
        this.settings = await paymentAPI.savePlatformSettings({ platformFeePercent: Number(this.form.platformFeePercent), feePayerDefault: this.form.feePayerDefault });
        this.saved = true;
      } catch (e) {
        this.error = typeof e === "string" ? e : "Could not save.";
      } finally {
        this.busy = false;
      }
    },
  },
  created() {
    this.load();
  },
};
</script>
